/**
 * Snap a target point to the nearest 45° angle from an origin point.
 * Used when Shift is held during pen-tool drawing and node-edit anchor drags.
 */
export function snapToAngle45(
  fromX: number,
  fromY: number,
  toX: number,
  toY: number
): { x: number; y: number } {
  const dx = toX - fromX
  const dy = toY - fromY
  const dist = Math.sqrt(dx * dx + dy * dy)

  if (dist === 0) return { x: toX, y: toY }
  const angle = Math.atan2(dy, dx)
  const snapped = Math.round(angle / (Math.PI / 4)) * (Math.PI / 4)

  return {
    x: fromX + dist * Math.cos(snapped),
    y: fromY + dist * Math.sin(snapped),
  }
}
